/**
 * Created by Roman on 2015-03-26.
 */


angular.module('fliptoWeb')
    .directive('ftSpinner', [function () {

        return {
            restrict: 'E',
            template: '<img src="/assets/images/utility/loader_512.gif" class="spinner-inline">'
        };
    }]);